import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import styles from '@features/shipping-methods/pickup/styles.module.scss'
import { ShopItem as ShopItemType } from '@features/shipping-methods/types'

import useShopTime from '@shared/hooks/useShopTime'
import Radio from '@shared/ui/radio'


interface ShopItemProps {
  shop: ShopItemType;
  handleShopClick: (shop: ShopItemType) => void;
  handleDeleteAddress: (shop: ShopItemType) => void;
  selected?: boolean;
  onSelect?: () => void;
}

const ShopItem = ({
  shop,
  selected,
  onSelect,
}: ShopItemProps) => {
  const { t: tmd } = useTranslation('modalDelivery')
  const { open, close, getShopStatus } = useShopTime(
    shop?.open_time || 0,
    shop?.close_time || 0,
  )

  const handleClick = () => {
    onSelect?.()
  }

  return (
    <li
      onClick={handleClick}
      className={classNames(styles.address, {
        [styles['address-initial']]: true,
        [styles['address--selected']]: selected,
      })}
    >
      <Radio radioSize="large" checked={selected} />

      <div className={styles.address__content}>
        <span className={styles.address__name}>{shop.address}</span>
        <div className={styles.details__time}>
          {!getShopStatus ? (
            <ReactSVG src="/icons/system.svg" wrapper="span" />
          ) : null}
          <p>
            {tmd('daily.open_hours', { open: open, close: close })}
            <span data-status={getShopStatus}>
              {getShopStatus ? tmd('status.open') : tmd('status.closed')}
            </span>
          </p>
        </div>
      </div>
    </li>
  )
}

interface ShopListForPickerProps {
  shops: (ShopItemType | null)[];
  handleShopClick: (shop: ShopItemType) => void;
  handleDeleteAddress: (shop: ShopItemType) => void;
  selectedShopId?: string | null;
}

export const ShopListForPicker = ({
  shops,
  handleShopClick,
  handleDeleteAddress,
  selectedShopId,
}: ShopListForPickerProps) => {
  return (
    <ul className={styles.addressList}>
      {shops?.map((shop) => {
        if (!shop) return null

        const isSelected = selectedShopId === shop.shop_id

        return (
          <ShopItem
            key={shop.shop_id}
            shop={shop}
            handleDeleteAddress={handleDeleteAddress}
            handleShopClick={handleShopClick}
            selected={isSelected}
            onSelect={() => handleShopClick(shop)}
          />
        )
      })}
    </ul>
  )
}
